import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useDispatch, useSelector } from 'react-redux';
import FJAIVideoEffectUploadControl from '../view/FJAIVideoEffectUploadControl.jsx';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';
import { useCallback, useMemo } from 'react';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import { VIDEO_EFFECT_STYLE_LIST } from '../../../../config/dataConfig/FJVideoEffectData.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
    UPLOAD_FILE_TO_VIDEO,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData.js';
import {
    UPLOAD_IMG_TO_VIDEO_EFFECT,
    UPLOAD_VIDEO_TO_VIDEO_EFFECT,
} from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';

const FJAIVideoEffectUploadControlContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const evFreeNum = useSelector(state => state.AIVideoGenerator.evFreeNum);
    const evTextValue = useSelector(state => state.AIVideoGenerator.evTextValue);
    const videoEffectUploadImageInfo = useSelector(state => state.AIVideoGenerator.videoEffectUploadImageInfo);
    const videoEffectUploadTwoImageInfo = useSelector(state => state.AIVideoGenerator.videoEffectUploadTwoImageInfo);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const videoEffectCredit = useSelector(state => state.AIVideoGenerator.videoEffectCredit);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const videoEffectStyleSelectId = useSelector(state => state.AIVideoGenerator.videoEffectStyleSelectId);
    const imageTypeIndex = useSelector(state => state.AIVideoGenerator.imageTypeIndex);
    const dancePresetList = useSelector(state => state.AIVideoGenerator.dancePresetList);
    const videoEffectUploadVideoInfo = useSelector(state => state.AIVideoGenerator.videoEffectUploadVideoInfo);
    const _onTextValueChange = (e, value) => {
        dispatch(FJActionAIVideoGenerator.changeTextValueAction(value));
    };

    const _onDelete = useCallback(
        index => {
            dispatch(FJActionAIVideoGenerator.updateVideoEffectUploadFileAction({}, index));
        },
        [dispatch],
    );
    const _onDeleteVideo = useCallback(() => {
        dispatch(FJActionAIVideoGenerator.updateVideoEffectUploadVideoInfoAction({}));
    }, [dispatch]);

    const _onUpload = useCallback(
        (file, index = 0, isUploadVideo = false) => {
            dispatch(FJActionAIVideoGenerator.uploadFileAction(file, index, { isUploadVideo }));
        },
        [dispatch],
    );
    const _onGenerate = useCallback(() => {
        dispatch(FJActionAIVideoGenerator.onGenerateVideoEffectAction());
    }, [dispatch]);

    const currentInfo = useMemo(() => {
        const item = VIDEO_EFFECT_STYLE_LIST.find(item => item.key === videoEffectStyleSelectId);
        return {
            ...item,
        };
    }, [videoEffectStyleSelectId]);

    const _onChangeMenuIndex = useCallback(
        index => {
            dispatch(FJActionAIVideoGenerator.changeVideoEffectImageTypeIndexAction(index));
        },
        [dispatch],
    );

    const _openMediaLibrary = (index = 0, mediaType = 'IMAGE') => {
        const isImage = mediaType === 'IMAGE';
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    // 上传文件规则
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode: isImage
                        ? UPLOAD_IMG_TO_VIDEO_EFFECT
                        : CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    acceptTypeNoTranscode: isImage
                        ? UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE
                        : UPLOAD_VIDEO_TO_VIDEO_EFFECT, // 上传后的校验使用
                    suffixTranscode: isImage
                        ? CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES
                        : CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = isImage ? ['IMAGE'] : ['VIDEO'];
                        return mediaTypes.includes(item.type);
                    },
                    mediaType,
                    // 上传文件之后返回的数据
                    callbackOptions: {
                        addIndex: index,
                        mediaType,
                    },
                },
            }),
        );
    };

    const _onDancePresetItemClick = useCallback(
        item => {
            dispatch(FJActionAIVideoGenerator.onVideoEffectDancePresetItemClickAction(item));
        },
        [dispatch],
    );

    return (
        <FJAIVideoEffectUploadControl
            freeNumCreation={evFreeNum}
            textValue={evTextValue}
            onTextValueChange={_onTextValueChange}
            videoEffectUploadImageInfo={videoEffectUploadImageInfo}
            videoEffectUploadTwoImageInfo={videoEffectUploadTwoImageInfo}
            taskStatus={taskStatus}
            videoEffectCredit={videoEffectCredit}
            isProjectLoading={isProjectLoading}
            onUpload={_onUpload}
            onDelete={_onDelete}
            onGenerate={_onGenerate}
            currentInfo={currentInfo}
            imageTypeIndex={imageTypeIndex}
            onChangeMenuIndex={_onChangeMenuIndex}
            openMediaLibrary={_openMediaLibrary}
            dancePresetList={dancePresetList}
            videoEffectUploadVideoInfo={videoEffectUploadVideoInfo}
            onDeleteVideo={_onDeleteVideo}
            onDancePresetItemClick={_onDancePresetItemClick}
        />
    );
};

export default FJAIVideoEffectUploadControlContainer;
